__webpack_require__.p = "https://satknowledgeassistant-dev.ey.com/";